<template>
  <div>
    <b-form>
        <div class="modal-form-legend">
            <legend v-translate>Details</legend>
        </div>

        <b-form-row>
            <b-col cols="12" lg="6">
                <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                    <template slot="label">
                        <span v-translate>Name</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-1" type="text" v-model="companyDetails.name" :class="[ getHighlightClass('name') ]" :placeholder="$gettext('Gekko')" />
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="12" lg="6">
                <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" label-for="input-2">
                    <template slot="label">
                        <span v-translate>Email</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-2" type="text" v-model="companyDetails.email" :class="[ getHighlightClass('email') ]" :placeholder="$gettext('john.doe@mycompany.com')" />
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-form-row>

        <b-form-row>
            <b-col cols="12" lg="6">
                <b-form-group id="input-group-13" label-class="gk-label-margin gk-modal-label" label-for="input-13">
                    <template slot="label">
                        <span v-translate>Website</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-13" type="text" v-model="companyDetails.website" :class="[ getHighlightClass('website') ]" :placeholder="$gettext('www.getgekko.com')" />
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="12" lg="6">
                <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label" label-for="input-3">
                    <template slot="label">
                        <span v-translate>Phone Number</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-3" type="text" v-model="companyDetails.phone_number" :class="[ getHighlightClass('phone_number') ]" :placeholder="$gettext('0612345678')" />
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-form-row>

        <b-form-row>
            <b-col cols="12" lg="6">
                <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" label-for="input-4">
                    <template slot="label">
                        <span v-translate>Type of Business</span>
                    </template>
                    <b-input-group>
                        <b-form-select id="input-4" :options="businessTypesOptions" :class="[ getHighlightClass('legal_form') ]" v-model="companyDetails.legal_form"></b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="12" lg="6">
                <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                    <template slot="label">
                        <span v-translate>Sector</span>
                    </template>
                    <b-input-group>
                        <b-form-select id="input-5" :options="sectorOptions" :class="[ getHighlightClass('sector') ]" v-model="companyDetails.sector">
                            <template #first>
                                <b-form-select-option :value="null" >---------</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-form-row>

        <b-form-group id="input-group-14" label-class="gk-label-margin gk-modal-label" label-for="input-14">
            <template slot="label">
                <span v-translate>Description</span>
            </template>
            <b-input-group>
                <b-form-input id="input-14" type="text" v-model="companyDetails.description" :class="[ getHighlightClass('description') ]" :placeholder="$gettext('Management and business consultancy')" />
            </b-input-group>
        </b-form-group>

        <div class="modal-form-legend">
            <legend v-translate>Address</legend>
        </div>
        
        <b-form-row>
            <b-col cols="12" lg="6">
                <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" label-for="input-6">
                    <template slot="label">
                        <span v-translate>Street</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-6" type="text" v-model="companyDetails.address" :class="[ getHighlightClass('address') ]" :placeholder="$gettext('Rokin')" />
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="12" lg="6">
                <b-form-group id="input-group-7" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                    <template slot="label">
                        <span v-translate>City</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-7" type="text" v-model="companyDetails.city" :class="[ getHighlightClass('city') ]" :placeholder="$gettext('Amsterdam')" />
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-form-row>

        <b-form-row>
            <b-col cols="12" lg="6">
                <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label" label-for="input-8">
                    <template slot="label">
                        <span v-translate>Postal Code</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-8" type="text" v-model="companyDetails.postal_code" :class="[ getHighlightClass('postal_code') ]" :placeholder="$gettext('1234AB')" />
                    </b-input-group>
                </b-form-group>
            </b-col>

            <b-col cols="12" lg="6">
                <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label" label-for="input-9">
                    <template slot="label">
                        <span v-translate>Country</span>
                    </template>
                    <b-input-group>
                        <b-form-select id="input-9" :options="countryOptions" v-model="companyDetails.country" :class="[ getHighlightClass('country') ]" :disabled="true"></b-form-select>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-form-row>

        <div class="modal-form-legend">
            <legend v-translate>Identification Numbers</legend>
        </div>

        <b-form-row>
            <b-col cols="12" lg="6">
                <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" label-for="input-10">
                <template slot="label">
                    <span v-translate>KVK</span>
                </template>
                <b-input-group>
                    <b-form-input id="input-10" type="text" v-model="companyDetails.kvk" :class="[ getHighlightClass('kvk') ]" :placeholder="$gettext('0123456789')" />
                </b-input-group>
            </b-form-group>
            </b-col>

            <b-col cols="12" lg="6">
                <b-form-group id="input-group-11" label-class="gk-label-margin gk-modal-label" label-for="input-11">
                    <template slot="label">
                        <span v-translate>VAT</span>
                    </template>
                    <b-input-group>
                        <b-form-input id="input-11" type="text" v-model="companyDetails.btw" :class="[ getHighlightClass('btw') ]" :placeholder="$gettext('NL012345678B00')" />
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-form-row>
        
        <b-form-group id="input-group-12" label-class="gk-label-margin gk-modal-label" label-for="input-12">
            <template slot="label">
                <span v-translate>Bank Account Number</span>
            </template>
            <b-input-group>
                <b-form-input id="input-12" type="text" v-model="companyDetails.bank_account_number" :class="[ getHighlightClass('bank_account_number') ]" :placeholder="$gettext('NLINGB000000123456789')" />
            </b-input-group>
        </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CompanyService from "@/store/services/company.service";

export default {
    name: "EditCompanyProfile",
    components: {},
    props: {
        selectedCompany: {
            type: Object,
            default() {return null}
        },
        targetData: {
            type: Array,
            default: () => {}
        },
    },
    data() {
        return {
            companyDetails: {},
            countryOptions: null,
            sectorOptions: null,
            businessTypesOptions: null,
            kvk_legal_form_options: null
        }
    },
    computed: {
        ...mapGetters({
            currentCompany: "main/getCurrentCompany"
        })
    },
    created() {
        this.companyDetails = JSON.parse(JSON.stringify(this.currentCompany));

        CompanyService.getAllChoices().then((response) => {
            this.countryOptions = response.data.countries;
            this.sectorOptions = response.data.sectors;
            if (this.currentCompany.country === "ES") this.businessTypesOptions = response.data.business_entities.es;
            else this.businessTypesOptions = response.data.business_entities.nl;
            this.kvk_legal_form_options = response.data.kvk_legal_form_options;
        });
        
        if (this.selectedCompany) {
            this.companyDetails.name = this.selectedCompany.handelsnaam;
            this.companyDetails.city = this.selectedCompany.plaats;
            this.companyDetails.address = this.selectedCompany.straatnaam;
            this.companyDetails.btw = this.selectedCompany.vestigingsnummer;
            this.companyDetails.kvk = this.selectedCompany.kvkNummer;

            let params = {url: this.selectedCompany.links[0].href};
            CompanyService.getKvkPageByUrl(params).then((response) => {
                if (response.data['_embedded']['hoofdvestiging']['adressen']) {
                    let address = response.data['_embedded']['hoofdvestiging']['adressen'][0];

                    let street_address = '';
                    if (address['straatnaam'])
                        street_address = address['straatnaam'];
                    if (address['huisnummer'])
                        street_address = street_address + ' ' + address['huisnummer'];
                    if (address['huisnummertoevoeging'])
                        street_address = street_address + '-' + address['huisnummertoevoeging'];

                    this.companyDetails.address = street_address;
                    this.companyDetails.postal_code = address['postcode'];
                    this.companyDetails.city = address['plaats'];
                }

                let business_activities = response.data['sbiActiviteiten'][0];
                this.companyDetails.description = business_activities['sbiOmschrijving'];
                this.companyDetails.sbi_description = business_activities['sbiOmschrijving'];
                this.companyDetails.sbi_code = business_activities['sbiCode'];

                if (response.data['_embedded']['hoofdvestiging']['websites'])
                    this.companyDetails.website = response.data['_embedded']['hoofdvestiging']['websites'][0];
                
                if (this.kvk_legal_form_options) {
                    if (response.data['_embedded']['eigenaar']['rechtsvorm'] in this.kvk_legal_form_options)
                        this.companyDetails.legal_form = this.kvk_legal_form_options[response.data['_embedded']['eigenaar']['rechtsvorm']];
                }
            });
        }
    },
    methods: {
        ...mapActions({ 
            loadCurrentCompany: "main/loadCurrentCompany"
        }),
        getHighlightClass (target_field) {
            let cssClass = ''
            const isRequired = this.targetData.find(o => o.key === target_field)
            if (isRequired) {
                cssClass = (!this.companyDetails[target_field]) ? 'emptyrequired' : ''
            }
            return cssClass
        },
        importCompany() {
            delete this.companyDetails.logo;  // avoid 400 error because it expects an image file (not the file path)
            CompanyService.update(this.companyDetails).then(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Success!"),
                    text: this.$gettext("The company details were imported correctly."),
                    variant: "success",
                    duration: 4
                });
                this.loadCurrentCompany(); // refresh store
                this.$emit("detailsSaved");
            }).catch(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Error"),
                    text: this.$gettext("The company details could not be saved."),
                    variant: "error",
                    duration: 4
                });
            });
        }
    }
}
</script>

<style lang="scss">
.gk-modal {
    .form-control.emptyrequired {
        border: 3px solid $colorBlue;
    }
}
</style>
